"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _styles = require("@mui/material/styles");
var _coreInfoBarActions = require("../../reducers/coreInfoBarActions");
var _SystemError = _interopRequireDefault(require("./SystemError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const BaseWrapper = (0, _styles.styled)('div', {
  shouldForwardProp: prop => prop !== 'hasBase'
})(_ref => {
  let {
    theme,
    hasBase
  } = _ref;
  return _objectSpread({}, hasBase && {
    padding: theme.spacing(2)
  });
});

/**
 * エラーバウンダリ部品
 */

class ErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "tearDownStuff", function () {
      this.setState({
        error: null,
        errorInfo: null
      });
    });
    this.state = {
      error: null,
      errorInfo: null
    };
  }
  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo, 'boundary');
    this.setState({
      error,
      errorInfo
    });
  }
  componentWillUnmount() {
    this.setState({
      error: null,
      errorInfo: null
    });
  }
  render() {
    if (this.state.error) {
      return /*#__PURE__*/_react.default.createElement(BaseWrapper, {
        hasBase: this.props.base
      }, /*#__PURE__*/_react.default.createElement(_SystemError.default, {
        boundaryError: {
          error: this.state.error,
          errorInfo: this.state.errorInfo
        }
      }));
    }
    return this.props.children;
  }
}
const mapDispatchToProps = dispatch => ({
  closeInfoBar: () => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.CLOSE]())
});
var _default = exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ErrorBoundary);